import React from 'react'
import ScheduleTabHeader from './ScheduleTabHeader'
import TaskSearch from './TaskSearch'
import PlanningCategoriesFilter from './PlanningCategoriesFilter'
import TasksFilter from './TasksFilter'

class ScheduleSidebar extends React.Component {
  constructor () {
    super()
    this.handleClick = this.handleClick.bind(this)
  }

  handleOnAllTasks () {
    $('form .search-task').val('')
    this.props.handleOnAllTasks()
  }

  handleClick () {
    this.props.handleCustomTaskClick('new')
  }

  buildEventTypes () {
    return ([
      {id: 1, text: 'Essential',  stateName: 'show_essential_tasks', state: this.props.filterStates.show_essential_tasks},
      {id: 2, text: 'Recommended', stateName: 'show_recommended_tasks', state: this.props.filterStates.show_recommended_tasks},
      {id: 3, text: 'Informational', stateName: 'show_information_only_tasks', state: this.props.filterStates.show_information_only_tasks}
    ])
  }

  leaveTypeCategories () {
    return (
      [
        {id: 1, text: 'Paid Leave',  stateName: 'show_paid_leave', state: this.props.filterStates.show_paid_leave, index_color: "#46cdc0"},
        {id: 2, text: 'Job Protected Leave', stateName: 'show_job_protected_leave', state: this.props.filterStates.show_job_protected_leave, index_color: "#23b1e3"}
      ]
    )
  }

  renderTaskSearch () {
    if (this.props.viewTab == 'calendar') {
      return null
    }

    return (
      <TaskSearch
        handleOnSubmit={this.props.handleOnTaskSearch}
        handleOnEmptySearch={this.props.handleOnAllTasks}
      />
    )
  }

  renderAddTask () {
    if (this.props.isLeavePlanPartner) {
      return null
    }

    return (
      <div className='add-custom-item' onClick={this.handleClick}>
        <span className='custom-item-icon'>
          <i className='fa fa-plus-circle' />
        </span>
        <span className='custom-item-label'>Add Task</span>
      </div>
    )
  }

  renderCalendarTimelineTab () {
    if (this.props.viewTab == 'calendar') {
      return (
        <div>
          <div className='category-title'>Leave Types</div>
          <div>
            <PlanningCategoriesFilter
              categories={this.leaveTypeCategories()}
              filterItems={this.props.filterItems}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div className='category-title'>Show Tasks</div>
          <div>
            <PlanningCategoriesFilter
              categories={this.buildEventTypes()}
              filterItems={this.props.filterItems}
            />
          </div>
        </div>
      )
    }
  }

  renderSettingMessange () {
    if (this.props.isLeavePlanPartner) {
      return null
    }

    return (
      <div className='setting-message'>
        <span>You can adjust the milestone dates on </span>
        <a className='setting-page' href='/employees/milestone_dates'>Settings page</a>
      </div>
    )
  }

  render () {
    return (
      <div id='schedule-sidebar' className='sidebar-elements'>
        <div>
          <ScheduleTabHeader
            handleTabChange={this.props.handleTabChange}
            viewTab={this.props.viewTab}
          />
          {this.renderTaskSearch()}
          {this.renderAddTask()}
          <div className='categories-div'>
            {this.renderCalendarTimelineTab()}
          </div>
          <div className='tasks-filter-div'>
            <div>
              <TasksFilter
                tasks={[{
                  id: 1,
                  text: 'Show Hidden Tasks',
                  stateName: 'show_hidden_tasks',
                  state: this.props.filterStates.show_hidden_tasks
                }]}
                filterItems={this.props.filterItems}
              />
            </div>
          </div>
          {this.renderSettingMessange()}
        </div>
      </div>
    )
  }
}

export default ScheduleSidebar;